import React, { useCallback, useEffect } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { FiEdit } from "react-icons/fi";
import Label from "../../Form/Label";
import Heading from "../../Form/Heading";
import { MdOutlineSettings } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ImageUpload from "../../Image-uploader/ImageUpload";
import GLPagesService from "../../Services/GLPagesService";
import { useState } from "react";
import SpinWheelService from "../../Services/SpinWheelService";
import GLpageTemplatePopup from "./GLpageTemplatePopup";
import { ToastContainer } from "react-toastify";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../../Constant/Notification";
import propertyService from "../../Services/PropertyService";
import Select from "react-select";
import AmenitiesService from "../../Services/AmenitiesService";
const GLpageCreatingSection = () => {
  const location = useLocation();

  const { GLPageId } = location.state || {};
  const [videoWarning, setVideoWarning] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);


  const [loadingState, setLoadingState] = useState({
    logo: false,
    bannerImages: false,
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    sectionForm: false,
    sectionMore: false,
  });

  const [headerLogo, setHeaderLogo] = useState(null);
  const [heroBanner, setHeroBanner] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  const handleClosePopup = useCallback(
    ({
      selectedStyleDetails,
      selectedProperty,
      selectedPropertyId,
      selectedPropertyTypeId,
    } = {}) => {
      const label = selectedStyleDetails?.label || formData.pageStyle?.label;
      const color = selectedStyleDetails?.color || formData?.pageStyle?.color;
      setFormData((prevState) => ({
        ...prevState,
        pageStyle: {
          label,
          color,
        },
        propertyName: selectedProperty || formData.propertyName,
        propertyId: selectedPropertyId || formData.propertyId,
        propertyType: selectedPropertyTypeId || formData.propertyType,
      }));

      setOpenPopup(false);
    },
    []
  );

  const [basicAmenities, setBasicAmenities] = useState([]);
  const [selectedBasic, setSelectedBasic] = useState([]);
  const [featuresAmenities, setFeaturesAmenities] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [nearbyAmenities, setNearbyAmenities] = useState([]);
  const [selectedNearby, setSelectedNearby] = useState([]);
  const handleSelectChange = (selected, type) => {
    const allOptions =
      type === "basic"
        ? basicAmenities
        : type === "features"
        ? featuresAmenities
        : nearbyAmenities;

    const isSelectAll = selected?.some((s) => s.value === "all");
  
    let newSelectedOptions = [];
  
    if (isSelectAll) {
     
      newSelectedOptions = allOptions.filter((option) => option.value !== "all");
    } else {
    
      newSelectedOptions = (selected || []).filter((option) => option.value !== "all");
    }
  
 
    if (type === "basic") {
      setSelectedBasic(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          basicAmenities: newSelectedOptions.map((option) => option.value),
        },
      });
    } else if (type === "features") {
      setSelectedFeatures(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          featuredAmenities: newSelectedOptions.map((option) => option.value),
        },
      });
    } else {
      setSelectedNearby(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          nearbyAmenities: newSelectedOptions.map((option) => option.value),
        },
      });
    }
  };
  const addSelectAllOption = (options) => {
  
    const filteredOptions = options.filter((option) => option.value !== "all");
    return [
      { value: "all", label: "Select All" },
      ...filteredOptions,
    ];
  };

  const {
    selectedStyleDetails,
    selectedProperty,
    selectedPropertyId,
    selectedPropertyTypeId,
  } = location.state || {};



  const imageSizeGuide = {
    "Luxurious and Rich": {
      logo: "150 x 60px",
      heroBannerSize: "430 x 820px",
      featuresSectionImage: "440 x 490px",
      formImage: "1440 x 620px",
      moreImages: "560 x 300px",
    },
    "Urban and Modern": {
      logo: "150 x 60px",
      heroBannerSize: "1360 x 700px",
      featuresSectionImage: "440 x 260px",
      formImage: "670 x 600px",
      moreImages: "490 x 220px",
    },
  };

  console.log("location", location.state);

  const [formData, setFormData] = useState({
    pageStyle: {
      label: selectedStyleDetails?.label,
      color: selectedStyleDetails?.color,
    },
    propertyName: selectedProperty,
    propertyId: selectedPropertyId,
    propertyType: selectedPropertyTypeId || "",
    header: { phoneNumber: "", logo: null },
    hero: {
      bannerImages: [],
      title: "",
      description: "",
    },
    featuresSection: {
      enable: false,
      title: "",
      section1: { image: "", title: "" },
      section2: { image: "", title: "" },
      section3: { image: "", title: "" },
      section4: { image: "", title: "" },
      section5: { image: "", title: "" },
    },
    formData: {
      enable: false,
      image: "",
      title: "",
      description: "",
      field1: { name: "", enable: false },
      field2: { name: "", enable: false },
      field3: { name: "", enable: false },
      field4: { name: "", enable: false },
    },
    gallery: {
      enable: false,
      title: "",
      images: [],
    },
    contactUs: {
      enable: false,
      title: "",
      map: {
        location: "",
        coordinates: { lat: "", lng: "" },
        address: "",
        email: "",
        phoneNumber: "",
      },
    },
    customerTestimonial: {
      enable: false,
      title: "",
      customer1: { name: "", feedback: "" },
      customer2: { name: "", feedback: "" },
      customer3: { name: "", feedback: "" },
    },
    videoSection: {
      enable: false,
      title: "",
      description: "",
      videoLink: "",
    },
    footer: {
      description: "",
    },
    propertyOverview: {
      enable: false,
      name: selectedProperty,
      description: "",
      overallArea: 0,
      availableUnits: 0,
      averagePrice: {
        min: 0,
        max: 0,
      },
      averageUnitSqft: {
        min: 0,
        max: 0,
      },
      launchDate: "",
      basicAmenities: [],
      featuredAmenities: [],
      nearbyAmenities: [],
      configuration: 0,
      possessionStatus: "",
    },
  });

  useEffect(() => {
    const basicAmenitiesFormatted = selectedBasic.map((item) => ({
      id: item.value,
      name: item.label,
    }));

    const featuredAmenitiesFormatted = selectedFeatures.map((item) => ({
      id: item.value,
      name: item.label,
    }));

    const nearbyAmenitiesFormatted = selectedNearby.map((item) => ({
      id: item.value,
      name: item.label,
    }));

    const filteredBasic = basicAmenitiesFormatted.filter(
      (item) => item.id !== "all"
    );
    const filteredFeatured = featuredAmenitiesFormatted.filter(
      (item) => item.id !== "all"
    );
    const filteredNearby = nearbyAmenitiesFormatted.filter(
      (item) => item.id !== "all"
    );

    setFormData((prevState) => ({
      ...prevState,
      propertyOverview: {
        ...prevState.propertyOverview,
        basicAmenities: filteredBasic,
        featuredAmenities: filteredFeatured,
        nearbyAmenities: filteredNearby,
      },
    }));
  }, [selectedBasic, selectedFeatures, selectedNearby]);

  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const response = await AmenitiesService.getAmentities();
        const data = response.data || [];
  
        const basicAms = addSelectAllOption(
          data
            .filter((item) => item.type === 1)
            .map((item) => ({ value: item.id, label: item.name }))
        );
        const featuresAms = addSelectAllOption(
          data
            .filter((item) => item.type === 2)
            .map((item) => ({ value: item.id, label: item.name }))
        );
        const nearbyAms = addSelectAllOption(
          data
            .filter((item) => item.type === 3)
            .map((item) => ({ value: item.id, label: item.name }))
        );
  
        setBasicAmenities(basicAms);
        setFeaturesAmenities(featuresAms);
        setNearbyAmenities(nearbyAms);
      } catch (error) {
        console.error("Error fetching amenities data:", error);
      }
    };
  
    fetchAmenities();
  }, []);

  

  const selectedLabel =
    selectedStyleDetails?.label || formData?.pageStyle.label;
  const sizeGuide = imageSizeGuide[selectedLabel];

  const handleSubmit = async () => {
    if (!formData.header?.logo) {
      showErrorToast("Logo is required.");
      return;
    }

    if (!formData.hero?.title) {
      showErrorToast("Hero Title is required.");
      return;
    }

    if (!formData.hero?.description) {
      showErrorToast("Hero Description is required.");
      return;
    }

    if (!formData.hero?.bannerImages?.length) {
      showErrorToast("Hero Banner Images are required.");
      return;
    }

    if (!formData.header?.phoneNumber) {
      showErrorToast("Phone Number is required.");
      return;
    }

    const phoneNumber = formData.header?.phoneNumber;
    const phoneRegex = /^[0-9]{10}$/;

    if (phoneNumber && !phoneRegex.test(phoneNumber)) {
      showErrorToast("Please enter a valid 10-digit phone number.");
      return;
    }

    const phoneNumberContact = formData.contactUs?.map?.phoneNumber;
    const phoneRegexContact = /^[0-9]{10}$/;
    if (phoneNumberContact && !phoneRegexContact.test(phoneNumberContact)) {
      showErrorToast("Please enter a valid 10-digit contact phone number.");
      return;
    }

    const email = formData.contactUs?.map?.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      showErrorToast("Please enter a valid email address.");
      return;
    }

    let dataToSend = {
      pageStyle: formData.pageStyle || "",
      propertyId: formData.propertyId || "",
      propertyType: formData.propertyType || "",
      header: {
        phoneNumber: formData.header.phoneNumber || "",
        logo: formData.header.logo || null,
      },
      hero: formData.hero || null,
      featuresSection: formData.featuresSection || null,
      formData: formData.formData || null,
      gallery: formData.gallery || null,
      contactUs: formData.contactUs || null,
      customerTestimonial: formData.customerTestimonial || null,
      videoSection: formData.videoSection || null,
      footer: formData.footer || null,
      status: formData.status || null,
      propertyOverview: {
        enable: formData.propertyOverview.enable,
        name: formData.propertyOverview.name,
        description: formData.propertyOverview.description,
        overallArea: formData.propertyOverview.overallArea,
        availableUnits: formData.propertyOverview.availableUnits,
        averagePrice: {
          min: formData.propertyOverview?.averagePrice?.min || 0,
          max: formData.propertyOverview?.averagePrice?.max || 0,
        },
        averageUnitSqft: {
          min: formData.propertyOverview?.averageUnitSqft?.min || 0,
          max: formData.propertyOverview?.averageUnitSqft?.max || 0,
        },
        launchDate: formData.propertyOverview.launchDate,
        configuration: formData.propertyOverview.configuration,
        possessionStatus: formData.propertyOverview.possessionStatus,
        basicAmenities: formData.propertyOverview.basicAmenities,
        featuredAmenities: formData.propertyOverview.featuredAmenities,
        nearbyAmenities: formData.propertyOverview.nearbyAmenities,
      },
    };

    dataToSend = Object.fromEntries(
      Object.entries(dataToSend).filter(([_, value]) => value !== undefined)
    );


    try {
      if (GLPageId) {
        const response = await GLPagesService.UpdateGLPage(
          GLPageId,
          dataToSend
        );
        console.log("Page updated successfully:", response);
        showSuccessToast("Page updated successfully!");
      } else {
        const response = await GLPagesService.CreateGLPage(dataToSend);
        console.log("Page created successfully:", response);
        showSuccessToast("Page created successfully!");
      }
      navigate("/admin/gl-pages");
    } catch (error) {
      console.error("Error saving GL page:", error.message);
      alert(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const getGLPageInfoData = async () => {
    try {
      const response = await GLPagesService.GetGLPageInfo(GLPageId);
      console.log("GL Page Info:", response);
      setFormData(response.data);
      setFormData((prevFormData) => ({
        ...prevFormData,
        propertyType: response.propertyType,
      }));
      setFormData((prevFormData) => ({
        ...prevFormData,
        propertyName: response.property.name,
      }));
      setFormData((prevFormData) => ({
        ...prevFormData,
        propertyOverview: {
         ...prevFormData.propertyOverview,
          name : response.property.name,
        },
      }));
      setFormData((prevFormData) => ({
        ...prevFormData,
        propertyId: response.property.id,
      }));
      const propertyData = response.data;
      if (propertyData.propertyOverview) {
        const basicAms = propertyData.propertyOverview.basicAmenities || [];
        const featuredAms = propertyData.propertyOverview.featuredAmenities || [];
        const nearbyAms = propertyData.propertyOverview.nearbyAmenities || [];
        
    
        setSelectedBasic(basicAms.map(item => ({ value: item.id, label: item.name })));
        setSelectedFeatures(featuredAms.map(item => ({ value: item.id, label: item.name })));
        setSelectedNearby(nearbyAms.map(item => ({ value: item.id, label: item.name })));
      }
    } catch (error) {
      console.error("Error getting GL Page Info:", error.message);
      alert(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

useEffect(() => {
  if (GLPageId) {
    getGLPageInfoData();
  }
}, [GLPageId]);

  const handleLogoImageChange = (e) => {
    handleImageChange(e, "logo");
  };

  const handleBannerImageChange = (e) => {
    handleImageChange(e, "bannerImages");
  };

  const handleSection1ImageChange = (e) => {
    handleImageChange(e, "section1");
  };

  const handleSection2ImageChange = (e) => {
    handleImageChange(e, "section2");
  };

  const handleSection3ImageChange = (e) => {
    handleImageChange(e, "section3");
  };

  const handleSection4ImageChange = (e) => {
    handleImageChange(e, "section4");
  };
  const handleSection5ImageChange = (e) => {
    handleImageChange(e, "section5");
  };

  const handleSectionFormImageChange = (e) => {
    handleImageChange(e, "sectionForm");
  };

  const handleSectionMoreImageChange = (e) => {
    handleImageChange(e, "sectionMore");
  };

  const handleImageChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/svg+xml",
      "image/webp",
      "image/jpeg",
      "image/jpg",
    ];

    if (!allowedTypes.includes(file.type)) {
      showErrorToast("Only PNG, SVG, WebP, JPG or JPEG images are allowed.");
      e.target.value = null;
      return;
    }

    if (file.size > 1024 * 1024) {
      showInfoToast("Image size must be less than 1MB.");
      e.target.value = null;
      return;
    }

    const selectedLabel =
      selectedStyleDetails?.label || formData.pageStyle?.label;
    const sizeGuide = imageSizeGuide[selectedLabel];

    if (!sizeGuide) {
      showInfoToast("Please select a valid style template first.");
      return;
    }

    let sizeText = "";

    if (type === "logo") {
      sizeText = sizeGuide.logo;
    } else if (type === "bannerImages") {
      sizeText = sizeGuide.heroBannerSize;
    } else if (type === "sectionForm") {
      sizeText = sizeGuide.formImage;
    } else if (type === "sectionMore") {
      sizeText = sizeGuide.moreImages;
    } else if (
      ["section1", "section2", "section3", "section4", "section5"].includes(
        type
      )
    ) {
      sizeText = sizeGuide.featuresSectionImage;
    }

    const [requiredWidth, requiredHeight] = sizeText
      .split("x")
      .map((n) => parseInt(n.trim()));

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;

    img.onload = async () => {
      const { width, height } = img;
      URL.revokeObjectURL(objectUrl);

      const tolerance = 20;

      const isWidthInRange =
        width >= requiredWidth - tolerance &&
        width <= requiredWidth + tolerance;
      const isHeightInRange =
        height >= requiredHeight - tolerance &&
        height <= requiredHeight + tolerance;

      if (!isWidthInRange || !isHeightInRange) {
        showInfoToast(
          `Please upload an image close to ${requiredWidth}x${requiredHeight}px for "${type}" (${selectedLabel}). Allowed tolerance is ±${tolerance}px.`
        );
        e.target.value = null;
        return;
      }

      setLoadingState((prevState) => ({
        ...prevState,
        [type]: true,
      }));

      try {
        const formData = new FormData();
        formData.append("file", file);
        const folderPath = "GLpage";

        const response = await SpinWheelService.createBannerImageTemplate(
          formData,
          folderPath
        );

        console.log("Image uploaded successfully:", response.data);

        if (type === "logo") {
          setFormData((prevState) => ({
            ...prevState,
            header: {
              ...prevState.header,
              logo: response.data.imageUrl,
            },
          }));
        } else if (
          ["section1", "section2", "section3", "section4", "section5"].includes(
            type
          )
        ) {
          setFormData((prevState) => ({
            ...prevState,
            featuresSection: {
              ...prevState.featuresSection,
              [type]: {
                ...prevState.featuresSection[type],
                image: response.data.imageUrl,
                title: prevState.featuresSection[type].title,
              },
            },
          }));
        } else if (type === "bannerImages") {
          setFormData((prevState) => ({
            ...prevState,
            hero: {
              ...prevState.hero,
              bannerImages: [
                ...prevState.hero.bannerImages,
                response.data.imageUrl,
              ],
            },
          }));
        } else if (type === "sectionMore") {
          setFormData((prevState) => ({
            ...prevState,
            gallery: {
              ...prevState.gallery,
              images: [...prevState.gallery.images, response.data.imageUrl],
            },
          }));
        } else if (type === "sectionForm") {
          setFormData((prevState) => ({
            ...prevState,
            formData: {
              ...prevState.formData,
              image: response.data.imageUrl,
            },
          }));
        }
      } catch (error) {
        console.error("Error uploading image:", error.response?.data);
      } finally {
        setLoadingState((prevState) => ({
          ...prevState,
          [type]: false,
        }));
      }
    };
  };

  const handelDeleteImages = async (imageUrl, type) => {
    try {
      const response = await GLPagesService.DeleteGLPageImage(imageUrl);

      if (type === "logo") {
        setFormData((prevState) => ({
          ...prevState,
          header: { ...prevState.header, logo: null },
        }));
      } else if (type === "bannerImages") {
        setFormData((prevState) => ({
          ...prevState,
          hero: {
            ...prevState.hero,
            bannerImages: prevState.hero.bannerImages.filter(
              (img) => img !== imageUrl
            ),
          },
        }));
      } else if (type === "sectionMore") {
        setFormData((prevState) => ({
          ...prevState,
          gallery: {
            ...prevState.gallery,
            images: prevState.gallery.images.filter((img) => img !== imageUrl),
          },
        }));
      } else if (type === "section1") {
        // Deleting the image in section1
        setFormData((prevState) => ({
          ...prevState,
          featuresSection: {
            ...prevState.featuresSection,
            section1: { ...prevState.featuresSection.section1, image: null },
          },
        }));
      } else if (type === "section2") {
        // Deleting the image in section2
        setFormData((prevState) => ({
          ...prevState,
          featuresSection: {
            ...prevState.featuresSection,
            section2: { ...prevState.featuresSection.section2, image: null },
          },
        }));
      } else if (type === "section3") {
        // Deleting the image in section3
        setFormData((prevState) => ({
          ...prevState,
          featuresSection: {
            ...prevState.featuresSection,
            section3: { ...prevState.featuresSection.section3, image: null },
          },
        }));
      } else if (type === "section4") {
        setFormData((prevState) => ({
          ...prevState,
          featuresSection: {
            ...prevState.featuresSection,
            section4: { ...prevState.featuresSection.section4, image: null },
          },
        }));
      } else if (type === "section5") {
        setFormData((prevState) => ({
          ...prevState,
          featuresSection: {
            ...prevState.featuresSection,
            section5: { ...prevState.featuresSection.section5, image: null },
          },
        }));
      } else if (type === "sectionForm") {
        setFormData((prevState) => ({
          ...prevState,
          formData: {
            ...prevState.formData,
            image: null,
          },
        }));
      }

      console.log("Image deleted successfully:", response);
    } catch (error) {
      console.error(
        "Error deleting image:",
        error.response?.data || error.message
      );
    }
  };

  const handlePreviewClick = () => {
    setShowPreview(!showPreview);
  };

  const navigate = useNavigate();
  console.log(selectedProperty);
  console.log(selectedStyleDetails?.label);
  const handelBack = () => {
    navigate("/admin/gl-pages");
  };

  return (
    <div className="bg-appGrayBackground h- pt-20">
      <ToastContainer />
      <AdminAppBar />
      <div className="px-14 ">
        <div className="flex flex-col">
          <div className="flex justify-between  items-center">
            <div className="flex items-center gap-3">
              <svg
                onClick={handelBack}
                className="cursor-pointer "
                width="16"
                height="28"
                viewBox="0 0 22 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                  fill="#399E79"
                />
              </svg>
              <h1 className="text-3xl font-bold">
                {GLPageId ? "Edit" : "New"} GL Page
              </h1>
            </div>

            <div className="flex gap-3">
              {GLPageId && (
                <button
                  onClick={handlePreviewClick}
                  className="mt-6 w-36 bg-emerald-600 cursor-pointer text-white py-2 rounded "
                >
                  {showPreview ? "Hide Preview" : "Show Preview"}
                </button>
              )}

              <button
                onClick={handleSubmit}
                className="mt-6 w-36 bg-emerald-600 cursor-pointer text-white py-2 rounded"
              >
                {GLPageId ? "Update" : "Create"}
              </button>
            </div>
          </div>

          {showPreview && (
            <div className="mt-6">
              <iframe
                src={`http://crm.glpages.s3-website.ap-south-1.amazonaws.com/gl-page/${GLPageId}`}
                width="100%"
                height="600px"
                title="Preview"
                frameBorder="0"
              />
            </div>
          )}

          <div className="flex p-3 bg-white max-w-fit gap-4 items-center rounded-lg">
            <div className="flex items-center text-nowrap gap-2">
              <div>Property:</div>
              <div className="text-xl font-bold">
                {selectedProperty || formData.propertyName}
              </div>
            </div>
            <div className="flex items-center gap-2 text-nowrap">
              <div>Page Style:</div>
              <div
                className={`text-xl font-bold ${
                  selectedStyleDetails?.color || formData?.pageStyle?.color
                }`}
              >
                {selectedStyleDetails?.label || formData?.pageStyle?.label}
              </div>

              <FiEdit
                onClick={() => setOpenPopup(!openPopup)}
                className="cursor-pointer text-lg hover:text-emerald-600"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-md p-6 mt-5">
          {/* {Header Section} */}

          <Heading text="Header" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <div className="flex  gap-2">
                <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                <Label label={"Header Logo"} />
                </div>
            

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="header-logo-file"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.logo || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="header-logo-file"
                      type="file"
                      className="hidden"
                      disabled={loadingState.logo || formData.header.logo}
                      onChange={handleLogoImageChange}
                    />
                  </label>

                  {loadingState.logo && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}

                  {formData.header.logo && !loadingState.logo && (
                    <div className="mt-4 relative">
                      <img
                        src={formData.header?.logo || loadingState.logo}
                        alt="Header Logo"
                        className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                      />
                      {/* Delete icon */}
                      <button
                        className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        onClick={() =>
                          handelDeleteImages(formData.header.logo, "logo")
                        }
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 ">
              <div className="flex  gap-2">
                <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                <Label label={"Display Phone Number"} />
                </div>
                
                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter number"
                    value={formData.header.phoneNumber}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        header: {
                          ...formData.header,
                          phoneNumber: e.target.value,
                        },
                      })
                    }
                    maxLength={10}
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {Hero Slider} */}

          <Heading text="Hero slider" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2">
              <div className="flex  gap-2">
                <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                <Label label={"Slider Image "} />
                </div>
                

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="hero-banner-file"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 "
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen "
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.heroBannerSize || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="hero-banner-file"
                      type="file"
                      className="hidden"
                      onChange={handleBannerImageChange}
                    />
                  </label>

                  {loadingState.bannerImages && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.hero.bannerImages.length > 0 &&
                    !loadingState.bannerImages && (
                      <div className="mt-4 flex gap-2 relative">
                        {formData.hero.bannerImages.map((image, index) => (
                          <div key={index} className="relative">
                            <img
                              src={image}
                              alt={`Banner Preview ${index + 1}`}
                              className="w-16 h-16 rounded-lg shadow-md"
                            />
                            <button
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                              onClick={() =>
                                handelDeleteImages(image, "bannerImages")
                              } // Pass the correct image URL
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </div>

              <div className="flex justify-between gap-2">
              <div className="flex  gap-2">
                <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                <Label label={"Slider Title"} />
                </div>
                
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter Title"
                    value={formData.hero.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        hero: {
                          ...formData.hero,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
              <div className="flex  gap-2">
                <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                <Label label={"Slider Description"} />
                </div>
                
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter Description"
                    value={formData.hero.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        hero: {
                          ...formData.hero,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={90}
                    className="w-full h-24 px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {Features Section} */}

          <Heading text="Features Section" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2 ">
                <Label label={"Enable This Section"} />

                <div class="flex  w-[75%]">
                  <label class="inline-flex  mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.featuresSection.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          featuresSection: {
                            ...formData.featuresSection,
                            enable: e.target.checked,
                          },
                        })
                      }
                      class="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Feature 1 Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.section1.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          section1: {
                            ...formData.featuresSection.section1,
                            title: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title 1"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Feature 1 Image"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="Feature1"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.featuresSectionImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="Feature1"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.section1 ||
                        formData?.featuresSection?.section1?.image
                          ? true
                          : false
                      }
                      onChange={handleSection1ImageChange}
                    />
                  </label>
                  {loadingState.section1 && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.featuresSection.section1.image &&
                    !loadingState.section1 && (
                      <div className="relative mt-4">
                        <img
                          src={formData.featuresSection.section1.image}
                          alt="Section 1 Image"
                          className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                        />
                        <button
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                          onClick={() =>
                            handelDeleteImages(
                              formData.featuresSection.section1.image,
                              "section1"
                            )
                          }
                        >
                          X
                        </button>
                      </div>
                    )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 mt-8">
                <Label label={"Feature 2 Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.section2.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          section2: {
                            ...formData.featuresSection.section1,
                            title: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title 2"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Feature 2 Image"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="Feature2"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.featuresSectionImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="Feature2"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.section2 ||
                        formData?.featuresSection?.section2?.image
                          ? true
                          : false
                      }
                      onChange={handleSection2ImageChange}
                    />
                  </label>
                  {loadingState.section2 && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.featuresSection.section2.image &&
                    !loadingState.section2 && (
                      <div className="relative mt-4">
                        <img
                          src={formData.featuresSection.section2.image}
                          alt="Section 2 Image"
                          className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                        />
                        <button
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                          onClick={() =>
                            handelDeleteImages(
                              formData.featuresSection.section2.image,
                              "section2"
                            )
                          }
                        >
                          X
                        </button>
                      </div>
                    )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 mt-8 ">
                <Label label={"Feature 3 Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.section3.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          section3: {
                            ...formData.featuresSection.section3,
                            title: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title 3"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Feature 3 Image"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="Feature3"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.featuresSectionImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="Feature3"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.section3 ||
                        formData?.featuresSection?.section3?.image
                          ? true
                          : false
                      }
                      onChange={handleSection3ImageChange}
                    />
                  </label>
                  {loadingState.section3 && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.featuresSection.section3.image &&
                    !loadingState.section3 && (
                      <div className="relative mt-4">
                        <img
                          src={formData.featuresSection.section3.image}
                          alt="Section 3 Image"
                          className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                        />
                        <button
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                          onClick={() =>
                            handelDeleteImages(
                              formData.featuresSection.section3.image,
                              "section3"
                            )
                          }
                        >
                          X
                        </button>
                      </div>
                    )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 mt-8">
                <Label label={"Feature 4 Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.section4.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          section4: {
                            ...formData.featuresSection.section4,
                            title: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title 4"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Feature 4 Image"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="Feature4"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.featuresSectionImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="Feature4"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.section4 ||
                        formData?.featuresSection?.section4?.image
                          ? true
                          : false
                      }
                      onChange={handleSection4ImageChange}
                    />
                  </label>
                  {loadingState.section4 && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.featuresSection.section4.image &&
                    !loadingState.section4 && (
                      <div className="relative mt-4">
                        <img
                          src={formData.featuresSection.section4.image}
                          alt="Section 4 Image"
                          className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                        />
                        <button
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                          onClick={() =>
                            handelDeleteImages(
                              formData.featuresSection.section4.image,
                              "section4"
                            )
                          }
                        >
                          X
                        </button>
                      </div>
                    )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 mt-8">
                <Label label={"Feature 5 Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.section5.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          section5: {
                            ...formData.featuresSection.section5,
                            title: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Feature 5 Image"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="Feature5"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.featuresSectionImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="Feature5"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.section5 ||
                        formData?.featuresSection?.section5?.image
                          ? true
                          : false
                      }
                      onChange={handleSection5ImageChange}
                    />
                  </label>
                  {loadingState.section5 && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.featuresSection.section5.image &&
                    !loadingState.section5 && (
                      <div className="relative mt-4">
                        <img
                          src={formData.featuresSection.section5.image}
                          alt="Section 5 Image"
                          className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                        />
                        <button
                          className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                          onClick={() =>
                            handelDeleteImages(
                              formData.featuresSection.section5.image,
                              "section5"
                            )
                          }
                        >
                          X
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>

          {/* {Property Overviews} */}
          <Heading text="Property Overviews" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Basic Info"} />

                <div class="flex  w-[75%]">
                  <label class="inline-flex  mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.propertyOverview?.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          propertyOverview: {
                            ...formData.propertyOverview,
                            enable: e.target.checked,
                          },
                        })
                      }
                      class="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Property Name"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    aria-label="Property name"
                    value={formData?.propertyOverview?.name}
                    readOnly
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Property Description"} />
                <div className="flex items-center justify-center w-[75%]">
                  <textarea
                    type="text"
                    value={formData?.propertyOverview?.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={1000}
                    placeholder="Enter Description"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6 mt-6">
                {/* Overall Area */}
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Overall Area"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="number"
                      value={formData?.propertyOverview?.overallArea === 0
                        ? ""
                        : formData?.propertyOverview?.overallArea || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              overallArea: parseInt(value) || 0,
                            },
                          });
                        }
                      }}
                      placeholder="Enter Area"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>

        {/* Average Price */}
<div className="flex items-center gap-4">
  <div className="w-1/2">
    <Label label={"Average Price"} />
  </div>
  <div className="w-[22%]">
    <input
      type="number"
      value={
        formData?.propertyOverview?.averagePrice?.min === 0 ?  ""
          : formData.propertyOverview.averagePrice.min
         
      }
      onChange={(e) => {
        const value = e.target.value;
        if (value.length <= 10) {
          setFormData({
            ...formData,
            propertyOverview: {
              ...formData.propertyOverview,
              averagePrice: {
                ...formData.propertyOverview.averagePrice,
                min: value ? parseInt(value) : undefined,
              },
            },
          });
        }
      }}
      placeholder="Min Price"
      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
    />
  </div>
  <div className="w-[25%]">
    <input
      type="number"
      value={
        formData?.propertyOverview?.averagePrice?.max  === 0 ?
          ""
          : formData.propertyOverview.averagePrice.max
      }
      onChange={(e) => {
        const value = e.target.value;
        if (value.length <= 10) {
          setFormData({
            ...formData,
            propertyOverview: {
              ...formData.propertyOverview,
              averagePrice: {
                ...formData.propertyOverview.averagePrice,
                max: value ? parseInt(value) : undefined,
              },
            },
          });
        }
      }}
      placeholder="Max Price"
      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
    />
  </div>
</div>

{/* Average Unit SQ.FT */}
<div className="flex items-center gap-4">
  <div className="w-1/2">
    <Label label={"Average Unit SQ.FT"} />
  </div>
  <div className="w-[25%]">
    <input
      type="number"
      value={
        formData?.propertyOverview?.averageUnitSqft?.min === 0 ?
          ""
          : formData.propertyOverview.averageUnitSqft.min
      }
      onChange={(e) => {
        const value = e.target.value;
        if (value.length <= 10) {
          setFormData({
            ...formData,
            propertyOverview: {
              ...formData.propertyOverview,
              averageUnitSqft: {
                ...formData.propertyOverview.averageUnitSqft,
                min: value ? parseInt(value) : undefined,
              },
            },
          });
        }
      }}
      placeholder="Min Unit SQ.FT"
      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
    />
  </div>

  <div className="w-[22%]">
    <input
      type="number"
      value={
        formData?.propertyOverview?.averageUnitSqft?.max  === 0 ?
          ""
          : formData.propertyOverview.averageUnitSqft.max
      }
      onChange={(e) => {
        const value = e.target.value;
        if (value.length <= 10) {
          setFormData({
            ...formData,
            propertyOverview: {
              ...formData.propertyOverview,
              averageUnitSqft: {
                ...formData.propertyOverview.averageUnitSqft,
                max: value ? parseInt(value) : undefined,
              },
            },
          });
        }
      }}
      placeholder="Max Unit SQ.FT"
      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
    />
  </div>
</div>


                {/* Available Units */}
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Available Units"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="number"
                      value={formData.propertyOverview?.availableUnits === 0 ? "" : formData.propertyOverview?.availableUnits || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              availableUnits: parseInt(value) || 0,
                            },
                          });
                        }
                      }}
                      placeholder="Enter Available Units"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>

                {/* Launch Date */}
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Launch Date"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="date"
                      value={formData.propertyOverview?.launchDate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          propertyOverview: {
                            ...formData.propertyOverview,
                            launchDate: e.target.value,
                          },
                        })
                      }
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>

                {/* Conditional rendering for villa-specific fields */}
                {formData.propertyType === "villa" && (
                  <>
                    {/* Configuration (BHK) */}
                    <div className="flex items-center gap-4">
                      <div className="w-1/2">
                        <Label label={"Configuration (BHK)"} />
                      </div>
                      <div className="w-1/2">
                        <input
                          type="number"
                          value={formData.propertyOverview?.configuration}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              propertyOverview: {
                                ...formData.propertyOverview,
                                configuration: e.target.value,
                              },
                            })
                          }
                          placeholder="Enter Configuration (BHK)"
                          className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>

                    {/* Possession Status */}
                    <div className="flex items-center gap-4">
                      <div className="w-1/2">
                        <Label label={"Possession Status"} />
                      </div>
                      <div className="w-1/2">
                        <select
                          value={formData.propertyOverview?.possessionStatus}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              propertyOverview: {
                                ...formData.propertyOverview,
                                possessionStatus: e.target.value,
                              },
                            })
                          }
                          className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                        >
                          <option value="">Select Status</option>
                          <option value="Ready to Move">Ready to Move</option>
                          <option value="Under Construction">
                            Under Construction
                          </option>
                          <option value="Upcoming">Upcoming</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <Label label={"Amenities"} className="mt-6" />

              <div className="my-4 flex items-center justify-between gap-4">
                <div className="w-[25%]">
                  <Label label="Basic Amenities" />
                </div>
                <div className="w-[78%]">
                  <Select
                    isMulti
                    options={addSelectAllOption(basicAmenities)}
                    value={selectedBasic}
                    onChange={(e) => handleSelectChange(e, "basic")}
                    className="w-full"
                    placeholder="Select Basic Amenities"
                  />
                </div>
              </div>

              <div className="my-4 flex items-center justify-between gap-4">
                <div className="w-[25%]">
                  <Label label="Featured Amenities" />
                </div>
                <div className="w-[78%]">
                  <Select
                    isMulti
                    options={addSelectAllOption(featuresAmenities)}
                    value={selectedFeatures}
                    onChange={(e) => handleSelectChange(e, "features")}
                    className="w-full"
                    placeholder="Select Featured Amenities"
                  />
                </div>
              </div>

              <div className="my-4 flex items-center justify-between gap-4">
                <div className="w-[25%]">
                  <Label label="Nearby Amenities" />
                </div>
                <div className="w-[78%]">
                  <Select
                    isMulti
                    options={addSelectAllOption(nearbyAmenities)}
                    value={selectedNearby}
                    onChange={(e) => handleSelectChange(e, "nearby")}
                    className="w-full"
                    placeholder="Select Nearby Amenities"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {Form Slider} */}

          <Heading text="Form" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />

                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.formData.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          formData: {
                            ...formData.formData,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Form Image"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="FormImage"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 ">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 ">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.formImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="FormImage"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.sectionForm || formData?.formData?.image
                          ? true
                          : false
                      }
                      onChange={handleSectionFormImageChange}
                    />
                  </label>
                  {loadingState.sectionForm && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.formData.image && !loadingState.sectionForm && (
                    <div className="mt-4 relative">
                      <img
                        src={formData.formData.image}
                        alt="Form Section Image"
                        className="w-16 h-16 rounded-lg shadow-md"
                      />

                      {/* Delete Button */}
                      <button
                        className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        onClick={() =>
                          handelDeleteImages(
                            formData.formData.image,
                            "sectionForm"
                          )
                        }
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter Section Title"
                    value={formData.formData.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Section Description"} />

                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.formData.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={120}
                    placeholder="Enter Description"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Field 1"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.formData.field1.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          field1: {
                            ...formData.formData.field1,
                            name: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={15}
                    placeholder="Enter Field 1"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Field 2"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.formData.field2.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          field2: {
                            ...formData.formData.field2,
                            name: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={15}
                    placeholder="Enter Field 2"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Field 3"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.formData.field3.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          field3: {
                            ...formData.formData.field3,
                            name: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={15}
                    placeholder="Enter Field 3"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Field 4"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.formData.field4.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          field4: {
                            ...formData.formData.field4,
                            name: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={15}
                    placeholder="Enter Field 4"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {More Images} */}
          <Heading text="More Images" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2 ">
                <Label label={"Enable This Section"} />

                <div class="flex  w-[75%]">
                  <label class="inline-flex  mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.gallery.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          gallery: {
                            ...formData.gallery,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />

                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Title"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter section title"
                    value={formData.gallery.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        gallery: {
                          ...formData.gallery,
                          title: e.target.value, // Update the title when the user types
                        },
                      })
                    }
                    maxLength={50}
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
              <div className="flex  justify-between gap-2 ">
                <Label label={"Images"} />

                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="MoreImages"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.moreImages || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="MoreImages"
                      type="file"
                      className="hidden"
                      disabled={loadingState.sectionMore}
                      onChange={handleSectionMoreImageChange}
                    />
                  </label>
                  {loadingState.sectionMore && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}

                  {formData.gallery.images.length > 0 &&
                    !loadingState.sectionMore && (
                      <div className="mt-4 flex gap-2">
                        {formData.gallery.images.map((image, index) => (
                          <div key={index} className="relative">
                            <img
                              src={image}
                              alt={`Gallery Preview ${index + 1}`}
                              className="w-16 h-16 rounded-lg shadow-md"
                            />

                            {/* Delete Button for each image */}
                            <button
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                              onClick={() =>
                                handelDeleteImages(image, "sectionMore")
                              }
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>

          {/* {Contact Us section Slider} */}

          <Heading text="Contact Us Section" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16 ">
            <div className="flex flex-col gap-3">
              {/* Enable Section */}
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.contactUs.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contactUs: {
                            ...formData.contactUs,
                            enable: e.target.checked, // Update enable field when the checkbox is toggled
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>

              {/* Section Title */}
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.contactUs.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Title"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              {/* Latitude & Longitude */}
              <div className="flex justify-between gap-2">
                <Label label={"Latitude & Longitude"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={
                      formData.contactUs.map.coordinates.lat !== "" &&
                      formData.contactUs.map.coordinates.lng !== ""
                        ? `${formData.contactUs.map.coordinates.lat}, ${formData.contactUs.map.coordinates.lng}`
                        : "" // Show empty if lat/lng is not set
                    }
                    onChange={(e) => {
                      const [lat, lng] = e.target.value
                        .split(",")
                        .map((item) => item.trim());

                      const latParsed = lat ? parseFloat(lat) : "";
                      const lngParsed = lng ? parseFloat(lng) : "";

                      if (
                        (!isNaN(latParsed) || lat === "") &&
                        (!isNaN(lngParsed) || lng === "")
                      ) {
                        setFormData({
                          ...formData,
                          contactUs: {
                            ...formData.contactUs,
                            map: {
                              ...formData.contactUs.map,
                              coordinates: {
                                lat: latParsed,
                                lng: lngParsed,
                              },
                            },
                          },
                        });
                      } else {
                        console.error(
                          "Invalid input, please enter valid numbers."
                        );
                      }
                    }}
                    placeholder="Enter Latitude & Longitude"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              {/* Address */}
              <div className="flex justify-between gap-2">
                <Label label={"Address"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.contactUs.map.address}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          map: {
                            ...formData.contactUs.map,
                            address: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={120}
                    placeholder="Enter Address"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              {/* Email */}
              <div className="flex justify-between gap-2">
                <Label label={"Email"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="email"
                    value={formData.contactUs.map.email}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          map: {
                            ...formData.contactUs.map,
                            email: e.target.value,
                          },
                        },
                      })
                    }
                    placeholder="Enter email"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              {/* Phone Number */}
              <div className="flex justify-between gap-2">
                <Label label={"Ph number"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.contactUs.map.phoneNumber}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          map: {
                            ...formData.contactUs.map,
                            phoneNumber: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={10}
                    placeholder="Enter phone number"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {Customer Testimonial Slider} */}

          <Heading text="Customer Testimonial" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              {/* Enable Section Toggle */}
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.customerTestimonial.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          customerTestimonial: {
                            ...formData.customerTestimonial,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>

              {/* Section Title */}
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter section title"
                    value={formData.customerTestimonial.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        customerTestimonial: {
                          ...formData.customerTestimonial,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>

              {/* Customer 1 Name and Testimonial */}
              {["customer1", "customer2", "customer3"].map(
                (customer, index) => (
                  <div key={customer}>
                    <div className="flex justify-between gap-2">
                      <Label label={`Customer ${index + 1}`} />
                      <div className="flex items-center justify-center w-[75%]">
                        <input
                          type="text"
                          placeholder={`Enter customer ${index + 1} name`}
                          value={formData.customerTestimonial[customer].name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              customerTestimonial: {
                                ...formData.customerTestimonial,
                                [customer]: {
                                  ...formData.customerTestimonial[customer],
                                  name: e.target.value,
                                },
                              },
                            })
                          }
                          maxLength={15}
                          className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>

                    <div className="flex justify-between gap-2 mt-4">
                      <Label label={`Customer Testimonial ${index + 1}`} />
                      <div className="flex items-center justify-center w-[75%]">
                        <input
                          type="text"
                          placeholder={`Enter Customer Testimonial ${
                            index + 1
                          }`}
                          value={
                            formData.customerTestimonial[customer].feedback
                          }
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              customerTestimonial: {
                                ...formData.customerTestimonial,
                                [customer]: {
                                  ...formData.customerTestimonial[customer],
                                  feedback: e.target.value,
                                },
                              },
                            })
                          }
                          maxLength={120}
                          className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          {/* {Video Slider} */}

          <Heading text="Video Section" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2">
                <Label label={"Enable This Section"} />

                <div class="flex  w-[75%]">
                  <label class="inline-flex  mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.videoSection.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          videoSection: {
                            ...formData.videoSection,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>

              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Title"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.videoSection.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        videoSection: {
                          ...formData.videoSection,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Title"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Video Link"} />

                <div className="flex flex-col gap-1 w-[75%] relative">
                  <div className="flex items-center justify-center w-full">
                    <input
                      type="text"
                      value={formData.videoSection.videoLink}
                      onChange={(e) => {
                        const value = e.target.value;
                        const youtubeRegex =
                          /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/).+/;

                        if (value === "" || youtubeRegex.test(value)) {
                          setFormData({
                            ...formData,
                            videoSection: {
                              ...formData.videoSection,
                              videoLink: value,
                            },
                          });
                          setVideoWarning(false);
                        } else {
                          setVideoWarning(true);
                          setTimeout(() => {
                            setVideoWarning(false);
                          }, 2000);
                        }
                      }}
                      placeholder="Paste the YouTube video link"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>

                  {videoWarning && (
                    <div className="absolute top-full left-0 mt-1 bg-red-500 text-white text-xs px-3 py-1 rounded shadow z-10 w-max">
                      Paste the YouTube video link
                    </div>
                  )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Description"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.videoSection.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        videoSection: {
                          ...formData.videoSection,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={120}
                    placeholder="Enter Section Description"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {footer Slider} */}

          <Heading text="Footer Message" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Description"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.footer.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        footer: {
                          ...formData.footer,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Description"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      {openPopup && (
        <GLpageTemplatePopup
          ClosePopup={handleClosePopup}
          GLPageId={GLPageId}
          initialPropertyType={formData.propertyType || "Villa"}
          initialProperty={formData.propertyName}
          initialStyle={formData.pageStyle}
          initialPropertyId={formData.propertyId}
        />
      )}
    </div>
  );
};

export default GLpageCreatingSection;
